/* ------------------------------------------------------------------------ */
/*		File: cmpCard_210.tsx                                               */
/*		Description: Component Implementation                               */
/*		Project: iSymWebSchool											    */
/*		Author: ISym Global Solutions Limited                               */
/*		Version: 1.0													    */
/* ------------------------------------------------------------------------ */


import React, { useState, useEffect } from 'react';
import { ICard } from "./cmpCard_210.d";
import "./cmpCard_210.css"

/* ------------------------------------------------------------------------ */

const Card_210: React.FC<ICard> = ({ card }: ICard) => {
    const [count, setCount] = useState(0);

    useEffect(() => {
        const duration = 1000; // Duration of the animation in milliseconds
        const incrementTime = 20; // Interval of increment
        const increment = Math.ceil(card.percentage! / (duration / incrementTime));

        const animateCount = () => {
            let start = 0;
            const counter = setInterval(() => {
                start += increment;
                if (start >= card.percentage!) {
                    start = card.percentage!;
                    clearInterval(counter);
                }
                setCount(start);
            }, incrementTime);
        };

        animateCount();

        // Reinicia el contador cada 3 segundos
        const interval = setInterval(() => {
            setCount(0); // Resetea el contador
            animateCount(); // Vuelve a ejecutar la animación
        }, 3000);

        return () => {
            clearInterval(interval); // Limpia el intervalo al desmontar el componente
        };
    }, [card.percentage]);

    return (
        <div className="card_210">
            <div className="card_210_percentage">
                {count}
                <span>%</span>
            </div>
            <div className="card_210_label">{card.label}</div>
            <div className="card_210_description">{card.description}</div>
        </div>
    );
};

export default Card_210;